import React from "react";
import type { ScanFieldKey } from "../../../types/scan";
import { needsFieldVerification } from "../../../utils/scan/ocr";
import type { FieldConfidence } from "../../../types/scan";

interface Props {
  field: ScanFieldKey;
  value?: string;
  fieldConfidence?: FieldConfidence;
}

const ScanFieldHint = ({ field, value, fieldConfidence }: Props) => {
  const conf = fieldConfidence?.[field];
  if (!needsFieldVerification(conf, Boolean(value?.trim()))) {
    return null;
  }
  return (
    <p className="text-amber-600 text-xs mt-1 mb-0" role="status">
      Lu automatiquement — à vérifier
    </p>
  );
};

export default ScanFieldHint;
